import './Logout.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Logger from '@KrashidBuilt/common/utils/logger';

import { ROUTE_MAP } from '../../routes';
import { logout } from '../../api/credentials';
import { UserContext } from '../../ctx';

const logger = new Logger('Logout');

/**
 * Logout Component
 * @augments {Component<Props, State>}
 */
class Logout extends Component {

    componentDidMount() {
        this.context.setUser(null, () => {
            logout();
            this.props.history.replace(ROUTE_MAP.LOGIN);
        });
    }

    render() {
        logger.extra({ _: this });
        return (
            <div className={'Logout'}>

            </div>
        );
    }
}

Logout.contextType = UserContext;

Logout.defaultProps = {
};

Logout.propTypes = {
    match: PropTypes.shape(),
    history: PropTypes.shape(),
};


export default Logout;